export default __webpack_public_path__ + "static/media/interview-topic.7cc5e8ff.jpeg";